import { Toast } from "vant";
import config from "../config";
import axios from "axios";
const wx = require("weixin-js-sdk");

export default {
  /**
   * 校验email
   */

  isEmail(value) {
    return /^[\w-]+(\.[\w-]+)*@[\w-]+(\.[\w-]+)+$/.test(value);
  },

  /**
   * 校验手机号码
   */
  isPhone(value) {
    return /^1[0-9]{10}$/.test(value);
  },

  /*
   * 校验正整数
   */
  isInteger(value) {
    return /^\+?[1-9][0-9]*$/.test(value);
  },
  /**
   * 存储localStorage
   */
  setStore(name, content) {
    if (!name) return;
    if (typeof content !== "string") {
      content = JSON.stringify(content);
    }
    name = config.STORE_KEY + name;
    window.localStorage.setItem(name, content);
  },

  /**
   * 获取localStorage
   */
  getStore(name) {
    if (!name) return;
    name = config.STORE_KEY + name;
    return window.localStorage.getItem(name);
  },

  /**
   * 删除localStorage
   */
  removeStore(name) {
    if (!name) return;
    name = config.STORE_KEY + name;
    window.localStorage.removeItem(name);
  },
  /**
   * 获取url上参数
   */
  getUrlParamByName(name) {
    const urlStr = window.location.search;
    const REG = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
    const r = urlStr.substr(1).match(REG);
    if (r != null) return unescape(r[2]);
    return null;
  },
  delParam(paramKey) {
    var url = window.location.href; //页面url
    var urlParam = window.location.search.substr(1);
    var beforeUrl = url.substr(0, url.indexOf("?"));
    var nextUrl = "";
    var arr = new Array();
    if (urlParam != "") {
      var urlParamArr = urlParam.split("&");
      for (var i = 0; i < urlParamArr.length; i++) {
        var paramArr = urlParamArr[i].split("=");
        if (paramArr[0] != paramKey) {
          arr.push(urlParamArr[i]);
        }
      }
    }
    if (arr.length > 0) {
      nextUrl = "?" + arr.join("&");
    }
    url = beforeUrl + nextUrl;
    return url;
  },
  //提示
  toast(msg) {
    Toast(msg);
  },
  // 日志
  log(error) {
    error && console.log(error);
  },
  // 删除字符串{text}中的某个{str}字符串
  spliceStr(text, str) {
    return text.replace(str, "");
  },
  // 微信分享中配置
  wxConfig(config) {
    const object = {
      debug: false,
      appId: config.appidF,
      timestamp: config.timestamp,
      nonceStr: config.noncestr,
      signature: config.signature,
      jsApiList: ["scanQRCode"],
    }
    wx.config(object);
  },
};
